<template>
  <div class="product-service-discuss">
    <div>{{discuss.totalUserLikeCount}}</div>
  </div>
</template>

<script>
export default {
  name: "ProductServiceDiscuss",
  computed: {
    discuss() {
      const data = this.$store.state.user.userComment.getCommentsByProductId;
      console.log(data);
      // 商品点赞数
      const totalUserLikeCount = data.userLikes.filter(
        e => e.targetName == "service"
      ).length;
      // 商品点赞人列表
      const totalUserInfos = data.userLikes
        .filter(e => e.targetName == "service")
        .map(e => {
          return data.userInfos.find(u => u.id == e.userId);
        });

      // 商品评论数
      const totalUserCommentCount = data.userComments.filter(
        e => e.targetName == "service"
      ).length;

      // 商品评论列表
      const userComments = data.userComments
        .filter(e => e.targetName == "service")
        .map(e => {
          return {
            ...e,

            // 评论人
            userInfo: data.userInfos.find(u => u.id == e.userId),
            // 点赞数
            userLikeCount: data.userLikes.filter(
              l => l.targetName == "comment" && l.targetId == e.id
            ).length,
            // 子评论
            userComments: data.userComments
              .filter(c => c.targetName == "comment" && c.targetId == e.id)
              .map(e => {
                return {
                  ...e,

                  userInfo: data.userInfos.find(u => u.id == e.userId)
                };
              })
          };
        });

      return {
        totalUserLikeCount,
        totalUserInfos,

        totalUserCommentCount,
        userComments
      };
    }
  },
  created() {},
  methods: {}
};
</script>

<style lang="less" scoped>
.product-service-discuss {
  width: 100%;
}
</style>

